module.exports = __webpack_public_path__ + "static/media/bubbles2.d.ts.6a56a0c4.map";